import wootAPI from './apiClient';

// Unauthenticated — same source of truth the backend signup flow reads
// (app/services/voxeleon/plans.rb via GET /public/api/v1/plans).
export const fetchPlans = async () => {
  const response = await wootAPI.get('public/api/v1/plans');
  return response.data;
};
